import {
  defaultAdminQueryParams,
  defaultFactorQueryParams,
  defaultPayeeQueryParams,
  defaultPayorQueryParams,
} from 'app/constants/routes';

import { NavigationState } from './contexts';

export const initialQueryStrings: NavigationState['queryStrings'] = {
  adminAdvancePayor: defaultAdminQueryParams.advancePayor,
  adminAdvances: defaultAdminQueryParams.advances,
  adminBulkRemove: defaultAdminQueryParams.bulkRemove,
  adminCompanyDetails: defaultAdminQueryParams.companyDetails,
  adminCreditExposure: defaultAdminQueryParams.creditLimitExposure,
  adminCreditLimit: defaultAdminQueryParams.creditLimitExceeded,
  adminCsrDashboard: defaultAdminQueryParams.csrDashboard,
  adminCsrInvoices: defaultAdminQueryParams.csrInvoices,
  adminCsrLoads: defaultAdminQueryParams.csrLoads,
  adminDashboard: defaultAdminQueryParams.dashboard,
  adminFactorAssignment: defaultAdminQueryParams.factorAssignment,
  adminFactorAssignmentAudit: defaultAdminQueryParams.factorAssignmentAudit,
  adminFactorAssignmentHistory: defaultAdminQueryParams.factorAssignmentHistory,
  adminInvoicePayDateChangeReport: defaultAdminQueryParams.invoicePayDateChangeReport,
  adminInvoices: defaultAdminQueryParams.invoices,
  adminMisdirectedPayments: defaultAdminQueryParams.misdirectedPayments,
  adminNoaActionConflictsHistoryList: defaultAdminQueryParams.noaActionConflictsHistoryList,
  adminNoaActionConflictsList: defaultAdminQueryParams.noaActionConflictsList,
  adminNoaCoachableNoasList: defaultAdminQueryParams.noaCoachableReport,
  adminNoaList: defaultAdminQueryParams.noaList,
  adminNoaPendingFactorsList: defaultAdminQueryParams.noaPendingFactorsList,
  adminNoaSearchList: defaultAdminQueryParams.noaSearchList,
  adminNoaSplitList: defaultAdminQueryParams.noaSplitList,
  adminPayorList: defaultAdminQueryParams.payorList,
  adminPendingCarrierBanks: defaultAdminQueryParams.pendingCarrierBanks,
  adminPreviousBankChanges: defaultAdminQueryParams.previousBankChanges,
  adminPromotionalCampaignRelationships: defaultAdminQueryParams.campaignRelationships,
  adminPromotionalCampaigns: defaultAdminQueryParams.promotionalCampaigns,
  adminSelectCarrierClaimedRelationships: '',
  adminSelectCarrierPotentialRelationships: '',
  adminSelectCarriers: defaultAdminQueryParams.selectCarriers,
  adminTriumphLoadAdvancePayor: defaultAdminQueryParams.advancePayor,
  adminTriumphLoadAdvances: defaultAdminQueryParams.advances,
  adminUnreconciledFundsPayorShow: defaultAdminQueryParams.unreconciledFundsPayorShow,
  adminUnreconciledFundsPayors: defaultAdminQueryParams.unreconciledFundsPayors,
  factorAllInvoices: defaultFactorQueryParams.allInvoices,
  factorAllLoads: defaultFactorQueryParams.allLoads,
  factorInvoices: defaultFactorQueryParams.invoices,
  factorLoads: defaultFactorQueryParams.loads,
  factorPayees: defaultFactorQueryParams.payeeRelationships,
  factorPayments: defaultFactorQueryParams.payments,
  factorPayors: defaultFactorQueryParams.payors,
  metricAggregates: defaultAdminQueryParams.metricsAggregateReport,
  metricHistory: '',
  noaProcessorNoaList: defaultAdminQueryParams.readyToProcessNoaList,
  payeeInvoices: defaultPayeeQueryParams.invoicesAndCreditNotes,
  payeePaperwork: defaultPayeeQueryParams.bills,
  payeePayments: defaultPayeeQueryParams.payments,
  payorBillingReport: defaultPayorQueryParams.billingReport,
  payorCreditLimitReport: defaultPayorQueryParams.creditLimitReport,
  payorCreditNotes: defaultPayorQueryParams.credits,
  payorGotpFeesReport: defaultPayorQueryParams.gotpFeesReport,
  payorHeldInvoices: defaultPayorQueryParams.heldInvoices,
  payorHighwayAlerts: defaultPayorQueryParams.highwayWatchlist,
  payorInvoiceRefundsReport: defaultPayorQueryParams.invoiceRefundsReport,
  payorInvoiceReview: defaultPayorQueryParams.invoiceReview,
  payorInvoices: defaultPayorQueryParams.invoices,
  payorLoads: defaultPayorQueryParams.loads,
  payorPaperwork: defaultPayorQueryParams.settlements,
  payorPayments: defaultPayorQueryParams.payments,
  payorPreviousSettlementReport: defaultPayorQueryParams.previousSettlements,
  payorPreviousWeeklySettlementReport: defaultPayorQueryParams.previousWeeklySettlements,
  payorRelationships: defaultPayorQueryParams.relationships,
  payorRevenueShareReport: defaultPayorQueryParams.revenueShare,
  payorUnreconciledFunds: defaultPayorQueryParams.unreconciledFunds,
};
